export default __webpack_public_path__ + "static/top-8-places-in-the-world-to-treatyourself-central-park-b20b93e9d05e5cd4bbea381b19b10c30.jpg";